__webpack_require__.p = "https://wxapp.gz-cmc.com/wxapp/2025/h5/bay-area-h5/prod/";